import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import {
  GoogleMap,
  useJsApiLoader,
  OverlayView,
  InfoWindow,
  Polyline,
} from "@react-google-maps/api";
import logoDTS from "./assets/logoData.png";

const GOOGLE_MAPS_API_KEY = "AIzaSyB9g0yILcgsg6xDCGHIeSeGzmGEK-XcwYg";
const GOOGLE_MAPS_LIBRARIES = ["drawing", "geometry", "visualization"];

const MAP_CONTAINER_STYLE = { height: "100%", width: "100%" };
const MAP_OPTIONS = {
  zoomControl: false,
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
};

const ROUTE_POLYLINE_OPTIONS = {
  strokeColor: "#3b82f6",
  strokeOpacity: 0.6,
  strokeWeight: 5,
};

const globalStyles = `
  body, html {
    margin: 0; padding: 0; width: 100%; height: 100%;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    background-color: #f4f6f8;
  }

  .app-bar {
    background-color: #050936;
    height: 60px; width: 100%;
    display: flex; align-items: center;
    padding: 0 20px; box-sizing: border-box;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
    position: fixed; top: 0; z-index: 2000;
  }

  .logo-container {
    display: flex; align-items: center; gap: 20px;
    color: white; font-weight: bold; font-size: 18px;
  }

  .logo-img { height: 45px; width: auto; }

  .main-content {
    margin-top: 60px;
    height: calc(100vh - 60px);
    width: 100vw;
    position: relative;
    background-color: #eef2f6;
  }

  .live-badge {
    position: absolute; top: 20px; left: 50%;
    transform: translateX(-50%);
    background: white; padding: 10px 20px;
    border-radius: 30px; box-shadow: 0 4px 15px rgba(0,0,0,0.1);
    z-index: 1000; display: flex; align-items: center;
    gap: 10px; font-weight: 600; color: #374151; font-size: 14px;
  }

  .live-dot {
    width: 10px; height: 10px; background-color: #10b981;
    border-radius: 50%; animation: pulse 1.5s infinite;
  }

  @keyframes pulse {
    0% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7); }
    70% { box-shadow: 0 0 0 10px rgba(16, 185, 129, 0); }
    100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }
  }

  .marker-container {
    position: relative; width: 60px; height: 60px;
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    cursor: pointer;
  }

  .truck-circle, .store-circle {
    width: 44px; height: 44px;
    border-radius: 50%; display: flex;
    align-items: center; justify-content: center;
    position: relative; box-shadow: 0 4px 8px rgba(0,0,0,0.3);
    border: 2px solid white; z-index: 2;
  }

  .truck-circle { background-color: #050936; }
  .store-circle { background-color: #ef4444; }
  .truck-icon, .store-icon { font-size: 22px; }

  .direction-wrapper {
    position: absolute; width: 56px; height: 56px;
    top: 50%; left: 50%; margin-top: -28px; margin-left: -28px;
    z-index: 1;
  }

  .direction-pointer {
    position: absolute; top: -6px; left: 50%;
    transform: translateX(-50%); width: 0; height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 14px solid;
    filter: drop-shadow(0px 2px 2px rgba(0,0,0,0.3));
  }

  .marker-label {
    background-color: white; color: #1f2937; padding: 2px 8px;
    border-radius: 6px; font-size: 11px; font-weight: bold;
    border: 1px solid #e5e7eb; box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    white-space: nowrap; position: absolute; bottom: -15px; z-index: 3;
  }

  .status-container { display: flex; justify-content: center; align-items: center; height: 100%; width: 100%; }
  .status-card {
    background: white; padding: 40px 30px; border-radius: 20px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08); text-align: center;
    max-width: 420px; width: 100%; display: flex; flex-direction: column;
    align-items: center; gap: 15px; animation: fadeIn 0.5s ease-out;
  }
  .spinner {
    width: 60px; height: 60px; border: 4px solid #f3f4f6;
    border-top: 4px solid #3b82f6; border-radius: 50%;
    animation: spin 1s linear infinite; margin-bottom: 15px;
  }
  @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }

  .order-details-card {
    position: absolute; bottom: 30px; left: 30px;
    background: white; padding: 20px; border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.15); z-index: 1000;
    max-width: 350px; border-left: 5px solid #050936;
  }

  .btn-primary {
    margin-top: 15px; background-color: #050936; color: white;
    border: none; padding: 10px 15px; border-radius: 6px;
    cursor: pointer; width: 100%; font-weight: 600; font-size: 14px;
    transition: background 0.2s;
  }
  .btn-primary:hover { background-color: #0a1163; }

  .modal-overlay {
    position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
    background: rgba(0,0,0,0.5); display: flex; align-items: center;
    justify-content: center; z-index: 3000;
  }
  .modal-content {
    background: white; width: 90%; max-width: 500px; max-height: 80vh;
    border-radius: 15px; display: flex; flex-direction: column; overflow: hidden;
    box-shadow: 0 15px 35px rgba(0,0,0,0.2);
  }
  .modal-header {
    padding: 20px; background: #f9fafb; border-bottom: 1px solid #e5e7eb;
    display: flex; justify-content: space-between; align-items: center;
  }
  .modal-body { padding: 0; overflow-y: auto; flex: 1; }
  .product-item {
    padding: 15px 20px; border-bottom: 1px solid #f3f4f6;
    display: flex; justify-content: space-between; align-items: center;
  }
  .product-info { flex: 1; }
  .product-name { font-weight: 600; font-size: 14px; color: #111827; margin-bottom: 2px; }
  .product-meta { font-size: 12px; color: #6b7280; }
  .product-price { font-weight: bold; color: #050936; font-size: 14px; text-align: right; }
  .close-btn { background: none; border: none; font-size: 24px; cursor: pointer; color: #9ca3af; }
`;

function RoutePath({ truckPos, destinationPos }) {
  const [routePoints, setRoutePoints] = useState([]);

  useEffect(() => {
    if (!truckPos || !destinationPos) return;

    const url = `https://router.project-osrm.org/route/v1/driving/${truckPos.lng},${truckPos.lat};${destinationPos.lng},${destinationPos.lat}?overview=full&geometries=geojson`;

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        if (data.routes && data.routes.length > 0) {
          const coordinates = data.routes[0].geometry.coordinates.map(
            (coord) => ({ lat: coord[1], lng: coord[0] }),
          );
          setRoutePoints(coordinates);
        }
      })
      .catch((err) => console.error("Error al obtener ruta real:", err));
  }, [truckPos, destinationPos]);

  if (routePoints.length === 0) return null;

  return <Polyline path={routePoints} options={ROUTE_POLYLINE_OPTIONS} />;
}

const getPointerColor = (vehiculo) => {
  if (vehiculo.velocidad === 0 && vehiculo.encendido === 1) return "#eab308";
  if (vehiculo.velocidad > 0) return "#10b981";
  return "#ef4444";
};

const URL_AUTH_TMS =
  "https://gestiondeflota.boltrack.net/apiultimamillav3/api/autenticacion/verificar-token-seguimiento";
const URL_GESTION = "https://gestiondeflota.boltrack.net/api/datos";

const DEFAULT_CENTER = { lat: -17.7833, lng: -63.1821 };

export default function TrackingTMSMap() {
  const { token } = useParams();
  const [status, setStatus] = useState("loading");
  const [vehicles, setVehicles] = useState([]);
  const [mapCenter, setMapCenter] = useState(DEFAULT_CENTER);
  const [errorMessage, setErrorMessage] = useState("");
  const [orderDetails, setOrderDetails] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const mapRef = useRef(null);
  const centerInitializedRef = useRef(false);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    language: "es",
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  useEffect(() => {
    if (mapRef.current && mapCenter) {
      mapRef.current.panTo(mapCenter);
    }
  }, [mapCenter]);

  useEffect(() => {
    let intervalId;
    let revalidarIntervalId;

    const validarAuth = async () => {
      try {
        const authResponse = await fetch(URL_AUTH_TMS, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token: token }),
        });

        if (!authResponse.ok)
          return { ok: false, msg: "Error de autenticación" };

        const authData = await authResponse.json();
        if (
          authData.code !== "SUCCESS" ||
          !authData.body ||
          authData.body.length === 0
        ) {
          return {
            ok: false,
            msg: authData.message || "No se encontró información del pedido.",
          };
        }

        const pedidos = authData.body;
        if (pedidos.every((p) => p.finalizado === 1))
          return { ok: false, finished: true };

        const placasUnicas = [
          ...new Set(pedidos.map((p) => p.valuePlaca).filter(Boolean)),
        ];
        return { ok: true, listaPlacas: placasUnicas, dataPedidos: pedidos };
      } catch (e) {
        return { ok: false, msg: "Error de conexión" };
      }
    };

    const iniciarTracking = async () => {
      const result = await validarAuth();
      if (!result.ok) {
        if (result.finished) setStatus("finished");
        else {
          setStatus("error");
          setErrorMessage(result.msg);
        }
        return;
      }

      setStatus("active");
      setOrderDetails(result.dataPedidos);

      const fetchUbicaciones = async () => {
        const nuevasUbicaciones = await Promise.all(
          result.listaPlacas.map(async (placa) => {
            try {
              const response = await fetch(URL_GESTION, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  data_op: { placa: placa.trim(), token, checkConsumoUM: true },
                  op: "READ-OBTENEREVENTOACTUALVEHICULO",
                }),
              });
              const evento = await response.json();
              if (!evento.error && evento.data.length > 0) {
                const d = evento.data[0];
                return {
                  id: placa.trim(),
                  lat: parseFloat(d.LATITUD),
                  lng: parseFloat(d.LONGITUD),
                  velocidad: d.VELOCIDAD || 0,
                  encendido: d.I_ENCENDIDO || 0,
                  orient: d.ORIENT || 0,
                };
              }
            } catch (e) {}
            return null;
          }),
        );

        const validos = nuevasUbicaciones.filter((v) => v !== null);
        setVehicles(validos);
        if (validos.length > 0 && !centerInitializedRef.current) {
          setMapCenter({ lat: validos[0].lat, lng: validos[0].lng });
          centerInitializedRef.current = true;
        }
      };

      fetchUbicaciones();
      intervalId = setInterval(fetchUbicaciones, 10000);
      revalidarIntervalId = setInterval(async () => {
        const rev = await validarAuth();
        if (!rev.ok) {
          clearInterval(intervalId);
          clearInterval(revalidarIntervalId);
          setStatus(rev.finished ? "finished" : "error");
        }
      }, 30000);
    };

    if (token) iniciarTracking();
    return () => {
      clearInterval(intervalId);
      clearInterval(revalidarIntervalId);
    };
  }, [token]);

  const destination =
    orderDetails.length > 0 &&
    orderDetails[0].latitud &&
    orderDetails[0].longitud
      ? {
          lat: parseFloat(orderDetails[0].latitud),
          lng: parseFloat(orderDetails[0].longitud),
        }
      : null;

  return (
    <>
      <style>{globalStyles}</style>
      <header className="app-bar">
        <div className="logo-container">
          <img src={logoDTS} alt="Logo" className="logo-img" />
          <span> Seguimiento de Carga (TMS)</span>
        </div>
      </header>

      <main className="main-content">
        {status === "loading" && (
          <div className="status-container">
            <div className="status-card">
              <div className="spinner"></div>
              <h2>Conectando...</h2>
            </div>
          </div>
        )}

        {status === "finished" && (
          <div className="status-container">
            <div className="status-card">
              <h2>Pedido Finalizado</h2>
              <p>La orden ha sido entregada con éxito.</p>
            </div>
          </div>
        )}

        {status === "error" && (
          <div className="status-container">
            <div className="status-card">
              <h2>Ruta no iniciada</h2>
              <p>{errorMessage}</p>
            </div>
          </div>
        )}

        {status === "active" && !isLoaded && (
          <div className="status-container">
            <div className="status-card">
              <div className="spinner"></div>
              <h2>Cargando mapa...</h2>
            </div>
          </div>
        )}

        {status === "active" && isLoaded && (
          <div style={{ height: "100%", width: "100%" }}>
            <div className="live-badge">
              <span className="live-dot"></span> Seguimiento Activo
            </div>

            {orderDetails.length > 0 && (
              <div className="order-details-card">
                <h3>Resumen del Envío</h3>
                <div style={{ fontSize: "14px", color: "#4b5563" }}>
                  <div>
                    <strong>Cliente:</strong> {orderDetails[0].cliente}
                  </div>
                  <div>
                    <strong>Documento:</strong>{" "}
                    {orderDetails[0].numeroDocumento}
                  </div>
                  <div>
                    <strong>Items en carga:</strong> {orderDetails.length}
                  </div>
                </div>
                <button
                  className="btn-primary"
                  onClick={() => setShowModal(true)}
                >
                  Ver Detalle de Productos
                </button>
              </div>
            )}

            {showModal && (
              <div
                className="modal-overlay"
                onClick={() => setShowModal(false)}
              >
                <div
                  className="modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="modal-header">
                    <h3 style={{ margin: 0 }}>Detalle de Carga</h3>
                    <button
                      className="close-btn"
                      onClick={() => setShowModal(false)}
                    >
                      &times;
                    </button>
                  </div>
                  <div className="modal-body">
                    {orderDetails.map((item, idx) => (
                      <div
                        key={item.idDetallePedido || idx}
                        className="product-item"
                      >
                        <div className="product-info">
                          <div className="product-name">{item.producto}</div>
                          <div className="product-meta">
                            Cant: {item.cantidad} {item.unidadMedida}
                          </div>
                        </div>
                        <div className="product-price">
                          {item.monto} {item.moneda}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            <GoogleMap
              mapContainerStyle={MAP_CONTAINER_STYLE}
              center={mapCenter}
              zoom={14}
              options={MAP_OPTIONS}
              onLoad={onMapLoad}
            >
              {destination && (
                <>
                  <OverlayView
                    position={destination}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                    getPixelPositionOffset={() => ({ x: -30, y: -30 })}
                  >
                    <div
                      className="marker-container"
                      onClick={() => setSelectedMarker({ type: "store" })}
                    >
                      <div className="store-circle">
                        <span className="store-icon">🏪</span>
                      </div>
                      <span className="marker-label">Destino</span>
                    </div>
                  </OverlayView>

                  {vehicles.map((v) => (
                    <RoutePath
                      key={`route-${v.id}`}
                      truckPos={{ lat: v.lat, lng: v.lng }}
                      destinationPos={destination}
                    />
                  ))}
                </>
              )}

              {vehicles.map((v) => (
                <OverlayView
                  key={v.id}
                  position={{ lat: v.lat, lng: v.lng }}
                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                  getPixelPositionOffset={() => ({ x: -30, y: -30 })}
                >
                  <div
                    className="marker-container"
                    onClick={() =>
                      setSelectedMarker({ type: "truck", id: v.id })
                    }
                  >
                    <div
                      className="direction-wrapper"
                      style={{ transform: `rotate(${v.orient}deg)` }}
                    >
                      <div
                        className="direction-pointer"
                        style={{ borderBottomColor: getPointerColor(v) }}
                      ></div>
                    </div>
                    <div className="truck-circle">
                      <span className="truck-icon">🚛</span>
                    </div>
                    <span className="marker-label">{v.id}</span>
                  </div>
                </OverlayView>
              ))}

              {selectedMarker?.type === "store" && destination && (
                <InfoWindow
                  position={destination}
                  onCloseClick={() => setSelectedMarker(null)}
                >
                  <div>Destino: {orderDetails[0].cliente}</div>
                </InfoWindow>
              )}

              {selectedMarker?.type === "truck" &&
                (() => {
                  const v = vehicles.find((x) => x.id === selectedMarker.id);
                  if (!v) return null;
                  return (
                    <InfoWindow
                      position={{ lat: v.lat, lng: v.lng }}
                      onCloseClick={() => setSelectedMarker(null)}
                    >
                      <div>
                        Unidad: {v.id}
                        <br />
                        Vel: {v.velocidad} km/h
                      </div>
                    </InfoWindow>
                  );
                })()}
            </GoogleMap>
          </div>
        )}
      </main>
    </>
  );
}
